module.exports = __webpack_public_path__ + "static/devfesttoulouse2018-09ef924202cfe2fc217eac34b1227e0d.png";